import AppContainer from "../Structure/AppContainer";
import React, { useContext, useEffect, useState } from "react";
import Select from "react-select";
import toast, { Toaster } from "react-hot-toast";
import AuthContext from "../../Context/AuthContext";
import { useNavigate } from "react-router-dom";
import useStateCallback from "../../util/customHooks/useStateCallback";
import ajaxStations from "../../util/remote/ajaxStations";
import { useFilter } from "../../Context/FilterContext";
import UpdateStationModal from "./UpdateStationModal";
import RegisterStationModal from "./RegisterStationModal";
const ViewFuelStation = () => {
  const { toggleFilter, filterVisible } = useFilter();
  var company_id = Number(window.localStorage.getItem("FuelFy@company_id"));
  const itemsPerPageOptions = [
    { value: 10, label: "10" },
    { value: 25, label: "25" },
    { value: 50, label: "50" },
    { value: 100, label: "100" },
  ];
  const { userId } = useContext(AuthContext);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const [ownersList, setOwnersList] = useState([]);
  const [meta, setMeta] = useState([]);
  const [page, setPage] = useState(1);
  const [viewType, setViewType] = useState("card view");
  const [search, setSearch] = useState("");
  const [itemsPerPage, setItemsPerPage] = useState(10);
  // Fetch Station Owners
  const fetchStations = async () => {
    setLoading(true);
    const data = {
      page: page,
      items_per_page: itemsPerPage,
      company_id: company_id,
      search: search || null,
    };
    setOwnersList([]);
    setMeta([]);
    const response = await ajaxStations.liststations(data);
    if (response.status === "OK") {
      setOwnersList(response.details.list || []);
      setMeta(response.details.meta?.list_of_pages || []);
    } else {
      toast.error(response.message);
    }
    setLoading(false);
  };
  useEffect(() => {
    fetchStations();
  }, [page, search, itemsPerPage, company_id]);
  const toggleView = (type) => setViewType(type);
  // Update modal
  const [update, setUpdate] = useStateCallback(false);
  const handleViewDetails = (owner) => {
    setUpdate(false, () =>
      setUpdate(<UpdateStationModal data={owner} func={fetchStations} />)
    );
  };
  // Register modal
  const [Registers, setRegisters] = useStateCallback(false);
  const handleRegister = () => {
    setRegisters(false, () =>
      setRegisters(<RegisterStationModal func={fetchStations} />)
    );
  };
  // Page numbers
  const setNextPageNumber = () => page < meta.length && setPage(page + 1);
  const setPreviousPageNumber = () => page > 1 && setPage(page - 1);
  const setPageNumber = (e, item) => {
    e.preventDefault();
    setPage(item);
  };
  // NEW FUNCTION: view Station works Station + Toggle Theme
  const handleSetActiveStation = (stationId) => {
    const confirmSet = window.confirm(
      "Are you sure you want to activate this station?"
    );
    if (confirmSet) {
      localStorage.setItem("FuelFy@station_id", stationId);
      navigate("/");
      // window.location.reload();
    }
  };
  const filteredActions = [
    {
      label: "Filter",
      icon: "fe fe-filter",
      className: "btn btn-secondary btn-sm ",
      onClick: () => toggleFilter(),
    },
    {
      label: "card view",
      icon: "fa-regular fa-address-card",
      className: "btn btn-success btn-sm",
      onClick: () => toggleView("card view"),
    },
    {
      label: "table view",
      icon: "fa-solid fa-table",
      className: "btn btn-success btn-sm",
      onClick: () => toggleView("table view"),
    },
    {
      label: "Register Station",
      icon: "fa-solid fa-file-pen",
      className: "btn btn-primary btn-sm",
      onClick: () => handleRegister(),
    },
  ].filter((action) => action.label !== viewType);
  return (
    <AppContainer
      title="Stations"
      previousPageTitle="Dashboard"
      actions={filteredActions}
    >
      <div className="container-fluid">
        <Toaster />
        {update}
        {Registers}
        {filterVisible && (
          <div className="row">
            <div className="col-sm-12 col-lg-12 col-xl-12">
              <div className="card shadow-sm border-0 rounded-3">
                <div className="card-body p-4">
                  <div className="bg-light p-3 rounded-3 border mb-3">
                    <div className="row g-3 align-items-end">
                      {/* Items per page */}
                      <div className="col-lg-2">
                        <label className="form-label fw-semibold">
                          Items per page
                        </label>
                        <Select
                          value={itemsPerPageOptions.find(
                            (opt) => opt.value === itemsPerPage
                          )}
                          onChange={(selected) => {
                            setPage(1);
                            setItemsPerPage(selected.value);
                          }}
                          options={itemsPerPageOptions}
                          isSearchable={false}
                          classNamePrefix="react-select"
                          styles={{
                            control: (provided) => ({
                              ...provided,
                              minHeight: "35px",
                              height: "35px",
                              fontSize: "0.875rem",
                            }),
                            dropdownIndicator: (provided) => ({
                              ...provided,
                              padding: "4px",
                            }),
                            clearIndicator: (provided) => ({
                              ...provided,
                              padding: "4px",
                            }),
                          }}
                        />
                      </div>
                      <div className="col-lg-7 d-flex justify-content-end gap-2">
                        <button
                          className="btn btn-primary btn-sm m-2"
                          onClick={fetchStations}
                        >
                          Apply
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
        {/* Loading / No Data */}
        {loading ? (
          <div className="text-center my-5 fs-5 text-muted">
            Loading stations...
          </div>
        ) : ownersList.length === 0 ? (
          <div className="text-center my-5 fs-5 text-muted">
            No stations found
          </div>
        ) : viewType === "table view" ? (
          <>
            <div className="row">
              <div className="col-sm-12 col-xl-12 col-lg-12">
                <div className="card custom-card">
                  <div className="card-body">
                    <div>
                      <h6 className="card-title mb-1">Fuel Stations</h6>
                      <p className="text-muted card-sub-title">
                        List of registered stations
                      </p>
                    </div>
                    <div className="table-responsive">
                      <table className="table table-bordered text-nowrap mb-0">
                        <thead>
                          <tr>
                            <th>#</th>
                            <th>Station Name</th>
                            <th>Station group</th>
                            <th>Owner</th>
                            <th>Location</th>
                            <th>Status</th>
                            <th>Created At</th>
                            <th>Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          {ownersList.map((station, index) => (
                            <tr key={station.id}>
                              <td>{(page - 1) * itemsPerPage + index + 1}</td>
                              <td>{station.station_name}</td>
                              <td>{station.group_name}</td>
                              <td>{station.owner_name}</td>
                              <td>{station.location}</td>
                              <td>
                                <span
                                  className={`badge ${
                                    station.status === "1"
                                      ? "bg-success"
                                      : "bg-danger"
                                  }`}
                                >
                                  {station.status === "1"
                                    ? "Active"
                                    : "Inactive"}
                                </span>
                              </td>
                              <td>{station.created_at}</td>
                              <td className="d-flex gap-2">
                                <button
                                  className="btn btn-sm btn-info"
                                  onClick={() => handleViewDetails(station)}
                                >
                                  <i className="fe fe-edit-2"></i>
                                </button>
                                {/* NEW BUTTON */}
                                <button
                                  className="btn btn-sm btn-outline-warning px-2 mx-1"
                                  onClick={() =>
                                    handleSetActiveStation(station.id)
                                  }
                                >
                                  <i class="fa-solid fa-sailboat"></i>
                                  &nbsp; navigate Station works
                                </button>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </>
        ) : (
          <>
            <div className="row">
              {ownersList.map((station) => (
                <div className="col-md-4 col-lg-3 mb-3" key={station.id}>
                  <div
                    className="card h-100"
                    style={{
                      borderRadius: "12px",
                      boxShadow: "4px 4px 12px rgba(0,0,0,0.1)",
                    }}
                  >
                    <div className="card-body text-center">
                      <h6 className="mb-1">{station.station_name}</h6>
                      <p className="text-muted mb-1">{station.location}</p>
                      <small className="d-block text-muted">
                        Owner : {station.owner_name}
                      </small>
                      <small className="d-block text-muted">
                        Group : {station.group_name}
                      </small>
                      <small className="d-block text-muted">
                        Created: {station.created_at}
                      </small>
                      <div className="mt-2">
                        <span
                          className={`badge px-3 py-1 ${
                            station.status === "1" ? "bg-success" : "bg-danger"
                          }`}
                        >
                          {station.status === "1" ? "Active" : "Inactive"}
                        </span>
                      </div>
                      <div className="d-flex justify-content-center mt-3 gap-2">
                        <button
                          className="btn btn-sm btn-outline-primary px-3"
                          onClick={() => handleViewDetails(station)}
                        >
                          <i className="fe fe-edit-2"></i> Edit
                        </button>
                        {/* NEW BUTTON */}
                        <button
                          className="btn btn-sm btn-outline-warning px-2 mx-1"
                          onClick={() => handleSetActiveStation(station.id)}
                        >
                          <i class="fa-solid fa-sailboat"></i>
                          &nbsp; navigate Station works
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </>
        )}
        {/* Pagination */}
        <div className="card-footer ">
          <nav className="d-flex justify-content-center">
            <ul className="pagination mb-0">
              <li className="page-item">
                <button className="page-link" onClick={setPreviousPageNumber}>
                  Prev
                </button>
              </li>
              {Array.isArray(meta) &&
                meta.map((item) =>
                  page === item ? (
                    <li className="page-item active" key={item}>
                      <span className="page-link">{item}</span>
                    </li>
                  ) : (
                    <li className="page-item" key={item}>
                      <a
                        className="page-link"
                        href="#"
                        onClick={(e) => setPageNumber(e, item)}
                      >
                        {item}
                      </a>
                    </li>
                  )
                )}
              <li className="page-item">
                <button className="page-link" onClick={setNextPageNumber}>
                  Next
                </button>
              </li>
            </ul>
          </nav>
        </div>
      </div>
    </AppContainer>
  );
};
export default ViewFuelStation;
